<template>
  <div class="page-content znjcTable" :style="defaultHeight">
    <div class="startTitle">粉丝历史变化</div>
    <el-row class="filter">
      <el-col>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="搜索">
            <el-input v-model="formInline.searchContent" placeholder="粉丝编码/粉丝姓名" clearable style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-select v-model="formInline.sex" placeholder="请选择" clearable style="width: 180px;">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <el-select v-model="formInline.dateType" placeholder="请选择" clearable style="width: 180px; float: left;" @change="dateSelectChange()">
              <el-option label="本月" value="0"></el-option>
              <el-option label="最近三个月" value="1"></el-option>
              <el-option label="最近六个月" value="2"></el-option>
              <el-option label="最近一年" value="3"></el-option>
              <el-option label="自定义" value="4"></el-option>
            </el-select>
            <el-date-picker style="width: 250px; float: left; margin-left: 15px;" type="daterange" v-model="time" :readonly="isDateShow" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onSubmit" style="background-color: #13C76B">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="fansId" label="粉丝编码" align="center" />
      <el-table-column prop="name" label="粉丝昵称" align="center" />
      <el-table-column prop="sex" label="粉丝性别" :formatter="judigSex" align="center" />
      <el-table-column prop="date" label="成为粉丝时间" align="center" />
    </el-table>
    <!-- 分页 -->
    <pagination v-show="total>0" :total="total" :page.sync="formInline.pageNum" :limit.sync="formInline.pageSize" @pagination="getMyFans" />
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import { myFans } from '@/api/fsHistoryChange'

export default {
  name: "fsHistroyChange",
  data () {
    return {
      defaultHeight: {
        height: ""
      },
      // 总条数
      total: 0,
      tableData: null, //表格数据
      // 时间框是否可以输入
      isDateShow: true,
      time: [],
      formInline: {
        searchContent: '',
        sex: '',
        pageNum: 1,
        pageSize: 10,
      }
    }
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.getMyFans();
  },
  methods: {
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    // 获取我的粉丝列表
    getMyFans () {
      myFans(this.addDateRange(this.formInline, this.time)).then(res => {
        this.tableData = res.data.data;
      })
    },
    //表格性别进行条件渲染
    judigSex (row, column, cellValue) {
      return cellValue === 1 ? '男' : '女';
    },
    // 开始搜索
    onSubmit () {
      this.getMyFans();
    },
    //监听时间
    dateSelectChange () {
      var dateType = this.formInline.dateType;
      if (parseInt(dateType) === 0) {
        var date = new Date();
        this.isDateShow = true;
        const start = date.getFullYear() + "-" + this.zeroFn(date.getMonth() + 1) + "-01";
        const end = date.getFullYear() + "-" + this.zeroFn(date.getMonth() + 1) + "-" + new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        this.time = [start, end];

      } else if (parseInt(dateType) === 1) {
        this.isDateShow = true;
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        this.time = [start, end];

      } else if (parseInt(dateType) === 2) {
        this.isDateShow = true;
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        this.time = [start, end];

      } else if (parseInt(dateType) === 3) {
        this.isDateShow = true;
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
        this.time = [start, end];

      } else if (parseInt(dateType) === 4) {
        this.isDateShow = false;
        this.time = [];
      } else if (dateType == '') {
        this.time = [];
      }
    },
    zeroFn (num) {
      return num < 10 ? "0" + num : num
    },
  },
}
</script>

<style scoped>
.znjcTable .lineH {
  /*line-height: 60px;*/
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ededed;
}
.znjcTable .filter {
  padding-left: 10px;
  padding-top: 22px;
  padding-bottom: 1px;
}
.znjcTable .textR {
  text-align: right;
}
.znjc_tit img {
  position: relative;
  /*top: 10px;*/
  left: 10px;
  width: 40px;
  height: 40px;
  display: inline-block;
}
.znjc_tit span {
  margin-left: 15px;
  display: inline-block;
  font-size: 28px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}
.seeqsfxBtn {
  margin-right: 20px;
  background-color: #59677f;
  border-radius: 3px;
}
.paginationBox {
  padding-right: 20px;
}
.paginationBox .el-pagination {
  display: inline-block !important;
}
.paginationBox .el-button {
  padding: 7px 8px;
  position: relative;
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/fsHistroyChange.vue